import { render, staticRenderFns } from "./ChatConfigureForm.vue?vue&type=template&id=62790107"
import script from "./ChatConfigureForm.vue?vue&type=script&lang=js"
export * from "./ChatConfigureForm.vue?vue&type=script&lang=js"
import style0 from "./ChatConfigureForm.vue?vue&type=style&index=0&id=62790107&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports